// a store persisted in sessionStorage that will keep track of the last 20 viewed products.
// it will save just the handles (string)

import { browser } from '$app/environment';
import { writable } from 'svelte/store';

const STORAGE_KEY = '__hey-harper-recently-viewed__';
const MAX_RECENTLY_VIEWED = 20;

const createRecentlyViewed = () => {
  const { subscribe, update } = writable<string[]>(
    browser ? JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '[]') : []
  );

  subscribe((recentlyViewed) => {
    if (browser) {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(recentlyViewed));
    }
  });

  return {
    subscribe,
    add: (handle: string) => {
      update((recentlyViewed) => {
        const newRecentlyViewed = [handle, ...recentlyViewed.filter((h) => h !== handle)];
        return newRecentlyViewed.slice(0, MAX_RECENTLY_VIEWED);
      });
    },
    remove: (handle: string) => {
      update((recentlyViewed) => recentlyViewed.filter((h) => h !== handle));
    }
  };
};

export const recentlyViewed = createRecentlyViewed();
